import type { ComponentType, ReactNode } from "react";

import { useReveal } from "@/hooks";
import type { RevealOptions } from "@/animations";

interface RevealProps extends RevealOptions {
  as?: ComponentType<{ className?: string; children?: ReactNode; ref?: React.Ref<HTMLDivElement> }> | "div" | "section";
  className?: string;
  children: ReactNode;
}

/**
 * 容器级滚动揭示：内部带 data-reveal 的子元素会依次淡入上移。
 */
export function Reveal({ as: Tag = "div", className, children, ...options }: RevealProps) {
  const scope = useReveal<HTMLDivElement>(options);
  return (
    <Tag ref={scope} className={className}>
      {children}
    </Tag>
  );
}

export default Reveal;
